import { render } from "./BreakCard.vue?vue&type=template&id=64330c19"
import script from "./BreakCard.vue?vue&type=script&lang=js"
export * from "./BreakCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__